import CartFrozenItems from './CartFrozenItems';

export default CartFrozenItems;
